var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChocolate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20280_301274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#B1B6EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.9 318C416.7 333.2 416.7 357.9 431.9 373L500 441.1V500H0V206.7C14.4 213.5 32.1 210.9 44 199L243 0H359L500 141.1V250L431.9 318Z",
    fill: "#BAC2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.6 175.4C343.5 180.5 135.5 197.4 81.3001 247.8C73.8001 255 69.7001 264.2 72.6001 274C75.5001 283.8 84.2001 290.3 92.9001 295C156.7 326.5 302.2 317.8 374.9 310.3C382.4 309.6 384 320.7 376.2 321.9C346.6 324.8 317 326.4 287.4 327.2C232.6 328 123.1 328.6 79.3001 295.9C69.3001 288.3 62.5001 276.7 64.3001 263.7C70.7001 222 165.8 203.9 201.3 196.6C274 183 347.7 176.3 421.5 172.5C422.3 172.5 423.1 173.1 423.1 174C423.1 174.6 422.4 175.3 421.6 175.4Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.7 402.5L202 435.1C192.8 437.2 183.7 431.3 181.6 422.2L123.5 162.9C121.4 153.8 127.3 144.6 136.4 142.5L240.1 119.3C248.1 168.4 257.4 174.3 297 165C301.9 163.9 306.8 164.4 311.5 163.2L360.5 382.1C362.6 391.3 356.8 400.4 347.7 402.5Z",
    fill: "#451D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.2 364.6L251.4 414.4C251.6 415.4 251.4 416.4 250.9 417.2C250.4 418 249.5 418.7 248.5 418.9L198.7 430.1C197.3 430.4 196 429.9 195.1 429L195 428.9C194.6 428.5 194.4 427.9 194.2 427.3L183 377.5C182.8 376.5 183 375.6 183.4 374.8C183.9 373.9 184.8 373.3 185.8 373L235.6 361.8C237.7 361.3 239.8 362.6 240.2 364.6Z",
    fill: "#7A4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 378L199.6 420.7L195.2 429.5C194.8 429.1 193.4 427.7 193.2 427.1L182.7 378.6C182.5 377.6 182.3 374.6 183.5 374.4L190 378Z",
    fill: "#5A2C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.1 417.9C250.6 418.8 249.8 419.5 248.7 419.7L198.9 430.9C197.5 431.2 196.2 430.7 195.2 429.6L199.6 420.8L241.6 411.4L251.1 417.9Z",
    fill: "#441C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.7 373.1L234.3 367.6L239 388.6C239 388.6 233.6 372.3 231.7 371.7C229.8 371.1 209.7 373.1 209.7 373.1Z",
    fill: "#AF7D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.2 351.6L309.4 401.4C309.6 402.4 309.4 403.4 308.9 404.2C308.4 405 307.5 405.7 306.5 405.9L256.7 417.1C255.3 417.4 254 416.9 253.1 416L253 415.9C252.6 415.5 252.4 414.9 252.2 414.3L241 364.5C240.8 363.5 241 362.6 241.4 361.8C241.9 360.9 242.8 360.3 243.8 360L293.6 348.8C295.7 348.3 297.8 349.6 298.2 351.6Z",
    fill: "#7A4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 365L257.6 407.7L253.2 416.5C252.8 416.1 251.4 414.7 251.2 414.1L240.7 365.6C240.5 364.6 240.3 361.6 241.5 361.4L248 365Z",
    fill: "#5A2C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.1 404.9C308.6 405.8 307.8 406.5 306.7 406.7L256.9 417.9C255.5 418.2 254.2 417.7 253.2 416.6L257.6 407.8L299.6 398.4L309.1 404.9Z",
    fill: "#441C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.7 360.1L292.3 354.6L297 375.6C297 375.6 291.6 359.3 289.7 358.7C287.8 358.1 267.7 360.1 267.7 360.1Z",
    fill: "#AF7D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2 338.7L367.4 388.5C367.6 389.5 367.4 390.5 366.9 391.3C366.4 392.1 365.5 392.8 364.5 393L314.7 404.2C313.3 404.5 312 404 311.1 403.1L311 403C310.6 402.6 310.4 402 310.2 401.4L299 351.6C298.8 350.6 299 349.7 299.4 348.9C299.9 348 300.8 347.4 301.8 347.1L351.6 335.9C353.7 335.3 355.8 336.6 356.2 338.7Z",
    fill: "#7A4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 352L315.6 394.7L311.2 403.5C310.8 403.1 309.4 401.7 309.2 401.1L298.7 352.6C298.5 351.6 298.3 348.6 299.5 348.4L306 352Z",
    fill: "#5A2C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.1 391.9C366.6 392.8 365.8 393.5 364.7 393.7L314.9 404.9C313.5 405.2 312.2 404.7 311.2 403.6L315.6 394.8L357.6 385.4L367.1 391.9Z",
    fill: "#441C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.7 347.1L350.3 341.6L355 362.6C355 362.6 349.6 346.3 347.7 345.7C345.8 345.1 325.7 347.1 325.7 347.1Z",
    fill: "#AF7D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.3 306.7L238.5 356.5C238.7 357.5 238.5 358.5 238 359.3C237.5 360.1 236.6 360.8 235.6 361L185.8 372.2C184.4 372.5 183.1 372 182.2 371.1L182.1 371C181.7 370.6 181.5 370 181.3 369.4L170.1 319.6C169.9 318.6 170.1 317.7 170.5 316.9C171 316 171.9 315.4 172.9 315.1L222.7 303.9C224.8 303.4 226.8 304.7 227.3 306.7Z",
    fill: "#7A4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.1 320.1L186.7 362.8L182.3 371.6C181.9 371.2 180.5 369.8 180.3 369.2L169.8 320.7C169.6 319.7 169.4 316.7 170.6 316.5L177.1 320.1Z",
    fill: "#5A2C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1 360C237.6 360.9 236.8 361.6 235.7 361.8L185.9 373C184.5 373.3 183.2 372.8 182.2 371.7L186.6 362.9L228.6 353.5L238.1 360Z",
    fill: "#441C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.8 315.2L221.4 309.7L226.1 330.7C226.1 330.7 220.7 314.4 218.8 313.8C216.9 313.2 196.8 315.2 196.8 315.2Z",
    fill: "#AF7D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.3 293.7L296.5 343.5C296.7 344.5 296.5 345.5 296 346.3C295.5 347.1 294.6 347.8 293.6 348L243.8 359.2C242.4 359.5 241.1 359 240.2 358.1L240.1 358C239.7 357.6 239.5 357 239.3 356.4L228.1 306.6C227.9 305.6 228.1 304.7 228.5 303.9C229 303 229.9 302.4 230.9 302.1L280.7 290.9C282.8 290.4 284.8 291.7 285.3 293.7Z",
    fill: "#7A4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.1 307.1L244.7 349.8L240.3 358.6C239.9 358.2 238.5 356.8 238.3 356.2L227.8 307.7C227.6 306.7 227.4 303.7 228.6 303.5L235.1 307.1Z",
    fill: "#5A2C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.1 347C295.6 347.9 294.8 348.6 293.7 348.8L243.9 360C242.5 360.3 241.2 359.8 240.2 358.7L244.6 349.9L286.6 340.5L296.1 347Z",
    fill: "#441C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.8 302.2L279.4 296.7L284.1 317.7C284.1 317.7 278.7 301.4 276.8 300.8C274.9 300.2 254.8 302.2 254.8 302.2Z",
    fill: "#AF7D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.3 280.8L354.5 330.6C354.7 331.6 354.5 332.6 354 333.4C353.5 334.2 352.6 334.9 351.6 335.1L301.8 346.3C300.4 346.6 299.1 346.1 298.2 345.2L298.1 345.1C297.7 344.7 297.5 344.1 297.3 343.5L286.1 293.7C285.9 292.7 286.1 291.8 286.5 291C287 290.1 287.9 289.5 288.9 289.2L338.7 278C340.8 277.4 342.8 278.7 343.3 280.8Z",
    fill: "#7A4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.1 294.1L302.7 336.8L298.3 345.6C297.9 345.2 296.5 343.8 296.3 343.2L285.8 294.7C285.6 293.7 285.4 290.7 286.6 290.5L293.1 294.1Z",
    fill: "#5A2C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.1 334C353.6 334.9 352.8 335.6 351.7 335.8L301.9 347C300.5 347.3 299.2 346.8 298.2 345.7L302.6 336.9L344.6 327.5L354.1 334Z",
    fill: "#441C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.8 289.2L337.4 283.7L342.1 304.7C342.1 304.7 336.7 288.4 334.8 287.8C332.9 287.2 312.8 289.2 312.8 289.2Z",
    fill: "#AF7D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.5 249.7L225.7 299.5C225.9 300.5 225.7 301.5 225.2 302.3C224.7 303.1 223.8 303.8 222.8 304L173 315.1C171.6 315.4 170.3 314.9 169.4 314L169.3 313.9C168.9 313.5 168.7 312.9 168.5 312.3L157.3 262.5C157.1 261.5 157.3 260.6 157.7 259.8C158.2 258.9 159.1 258.3 160.1 258L209.9 246.8C212 246.4 214 247.7 214.5 249.7Z",
    fill: "#7A4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.3 263.1L173.9 305.8L169.5 314.6C169.1 314.2 167.7 312.8 167.5 312.2L157 263.7C156.8 262.7 156.6 259.7 157.8 259.5L164.3 263.1Z",
    fill: "#5A2C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.3 302.9C224.8 303.8 224 304.5 222.9 304.7L173.1 315.9C171.7 316.2 170.4 315.7 169.4 314.6L173.8 305.8L215.8 296.4L225.3 302.9Z",
    fill: "#441C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 258.1L208.6 252.6L213.3 273.6C213.3 273.6 207.9 257.3 206 256.7C204.1 256.2 184 258.1 184 258.1Z",
    fill: "#AF7D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.5 236.7L283.7 286.5C283.9 287.5 283.7 288.5 283.2 289.3C282.7 290.1 281.8 290.8 280.8 291L231 302.1C229.6 302.4 228.3 301.9 227.4 301L227.3 300.9C226.9 300.5 226.7 299.9 226.5 299.3L215.3 249.5C215.1 248.5 215.3 247.6 215.7 246.8C216.2 245.9 217.1 245.3 218.1 245L267.9 233.8C270 233.4 272 234.7 272.5 236.7Z",
    fill: "#7A4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3 250.1L231.9 292.8L227.5 301.6C227.1 301.2 225.7 299.8 225.5 299.2L215 250.7C214.8 249.7 214.6 246.7 215.8 246.5L222.3 250.1Z",
    fill: "#5A2C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.3 289.9C282.8 290.8 282 291.5 280.9 291.7L231.1 302.9C229.7 303.2 228.4 302.7 227.4 301.6L231.8 292.8L273.8 283.4L283.3 289.9Z",
    fill: "#441C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 245.1L266.6 239.6L271.3 260.6C271.3 260.6 265.9 244.3 264 243.7C262.1 243.2 242 245.1 242 245.1Z",
    fill: "#AF7D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.5 223.7L341.7 273.5C341.9 274.5 341.7 275.5 341.2 276.3C340.7 277.1 339.8 277.8 338.8 278L289 289.1C287.6 289.4 286.3 288.9 285.4 288L285.3 287.9C284.9 287.5 284.7 286.9 284.5 286.3L273.3 236.5C273.1 235.5 273.3 234.6 273.7 233.8C274.2 232.9 275.1 232.3 276.1 232L325.9 220.8C328 220.4 330 221.7 330.5 223.7Z",
    fill: "#7A4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.3 237.1L289.9 279.8L285.5 288.6C285.1 288.2 283.7 286.8 283.5 286.2L273 237.7C272.8 236.7 272.6 233.7 273.8 233.5L280.3 237.1Z",
    fill: "#5A2C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.3 276.9C340.8 277.8 340 278.5 338.9 278.7L289.1 289.9C287.7 290.2 286.4 289.7 285.4 288.6L289.8 279.8L331.8 270.4L341.3 276.9Z",
    fill: "#441C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 232.1L324.6 226.6L329.3 247.6C329.3 247.6 323.9 231.3 322 230.7C320.1 230.1 300 232.1 300 232.1Z",
    fill: "#AF7D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.5 191.8L212.7 241.6C212.9 242.6 212.7 243.6 212.2 244.4C211.7 245.2 210.8 245.9 209.8 246.1L160 257.2C158.6 257.5 157.3 257 156.4 256.1L156.3 256C155.9 255.6 155.7 255 155.5 254.4L144.3 204.6C144.1 203.6 144.3 202.7 144.7 201.9C145.2 201 146.1 200.4 147.1 200.1L196.9 188.9C199 188.5 201 189.8 201.5 191.8Z",
    fill: "#7A4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3 205.2L160.9 247.9L156.5 256.7C156.1 256.3 154.7 254.9 154.5 254.3L144 205.8C143.8 204.8 143.6 201.8 144.8 201.6L151.3 205.2Z",
    fill: "#5A2C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.3 245C211.8 245.9 211 246.6 209.9 246.8L160.2 258C158.8 258.3 157.5 257.8 156.5 256.7L160.9 247.9L202.9 238.5L212.3 245Z",
    fill: "#441C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 200.2L195.6 194.7L200.3 215.7C200.3 215.7 194.9 199.4 193 198.8C191.1 198.3 171 200.2 171 200.2Z",
    fill: "#AF7D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.5 178.8L270.7 228.6C270.9 229.6 270.7 230.6 270.2 231.4C269.7 232.2 268.8 232.9 267.8 233.1L218 244.2C216.6 244.5 215.3 244 214.4 243.1L214.3 243C213.9 242.6 213.7 242 213.5 241.4L202.3 191.6C202.1 190.6 202.3 189.7 202.7 188.9C203.2 188 204.1 187.4 205.1 187.1L254.9 175.9C257 175.5 259 176.8 259.5 178.8Z",
    fill: "#7A4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.3 192.2L218.9 234.9L214.5 243.7C214.1 243.3 212.7 241.9 212.5 241.3L202 192.8C201.8 191.8 201.6 188.8 202.8 188.6L209.3 192.2Z",
    fill: "#5A2C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.3 232C269.8 232.9 269 233.6 267.9 233.8L218.2 245C216.8 245.3 215.5 244.8 214.5 243.7L218.9 234.9L260.9 225.5L270.3 232Z",
    fill: "#441C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 187.2L253.6 181.7L258.3 202.7C258.3 202.7 252.9 186.4 251 185.8C249.1 185.3 229 187.2 229 187.2Z",
    fill: "#AF7D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.5 165.8L328.7 215.6C328.9 216.6 328.7 217.6 328.2 218.4C327.7 219.2 326.8 219.9 325.8 220.1L276 231.2C274.6 231.5 273.3 231 272.4 230.1L272.3 230C271.9 229.6 271.7 229 271.5 228.4L260.3 178.6C260.1 177.6 260.3 176.7 260.7 175.9C261.2 175 262.1 174.4 263.1 174.1L312.9 162.9C315 162.5 317 163.8 317.5 165.8Z",
    fill: "#7A4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.3 179.2L276.9 221.9L272.5 230.7C272.1 230.3 270.7 228.9 270.5 228.3L260 179.8C259.8 178.8 259.6 175.8 260.8 175.6L267.3 179.2Z",
    fill: "#5A2C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.3 219C327.8 219.9 327 220.6 325.9 220.8L276.2 232C274.8 232.3 273.5 231.8 272.5 230.7L276.9 221.9L318.9 212.5L328.3 219Z",
    fill: "#441C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287 174.2L311.6 168.7L316.3 189.7C316.3 189.7 310.9 173.4 309 172.8C307.1 172.2 287 174.2 287 174.2Z",
    fill: "#AF7D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.7 134.7L199.9 184.5C200.1 185.5 199.9 186.5 199.4 187.3C198.9 188.1 198 188.8 197 189L147.2 200.2C145.8 200.5 144.5 200 143.6 199.1L143.5 199C143.1 198.6 142.9 198 142.7 197.4L131.5 147.6C131.3 146.6 131.5 145.7 131.9 144.9C132.4 144 133.3 143.4 134.3 143.1L184.1 131.9C186.2 131.4 188.3 132.7 188.7 134.7Z",
    fill: "#7A4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5 148.1L148.1 190.8L143.7 199.6C143.3 199.2 141.9 197.8 141.7 197.2L131.2 148.7C131 147.7 130.8 144.7 132 144.5L138.5 148.1Z",
    fill: "#5A2C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5 188C199 188.9 198.2 189.6 197.1 189.8L147.3 201C145.9 201.3 144.6 200.8 143.6 199.7L148 190.9L190 181.5L199.5 188Z",
    fill: "#441C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.2 143.2L182.8 137.7L187.5 158.7C187.5 158.7 182.1 142.4 180.2 141.8C178.3 141.2 158.2 143.2 158.2 143.2Z",
    fill: "#AF7D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.7 121.7L257.9 171.5C258.1 172.5 257.9 173.5 257.4 174.3C256.9 175.1 256 175.8 255 176L205.2 187.2C203.8 187.5 202.5 187 201.6 186.1L201.5 186C201.1 185.6 200.9 185 200.7 184.4L189.5 134.6C189.3 133.6 189.5 132.7 189.9 131.9C190.4 131 191.3 130.4 192.3 130.1L242.1 118.9C244.2 118.4 246.3 119.7 246.7 121.7Z",
    fill: "#7A4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.5 135.1L206.1 177.8L201.7 186.6C201.3 186.2 199.9 184.8 199.7 184.2L189.2 135.7C189 134.7 188.8 131.7 190 131.5L196.5 135.1Z",
    fill: "#5A2C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.5 175C257 175.9 256.2 176.6 255.1 176.8L205.3 188C203.9 188.3 202.6 187.8 201.6 186.7L206 177.9L248 168.5L257.5 175Z",
    fill: "#441C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.2 130.2L240.8 124.7L245.5 145.7C245.5 145.7 240.1 129.4 238.2 128.8C236.3 128.2 216.2 130.2 216.2 130.2Z",
    fill: "#AF7D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.1 92.7L337.4 141.6C337.1 142.6 336.4 143.4 335.6 143.8C334.7 144.3 333.7 144.4 332.7 144.1L283.8 129.4C282.5 129 281.5 127.9 281.2 126.6C281.2 126.5 281.2 126.5 281.2 126.4C281.1 125.8 281.1 125.2 281.3 124.6L296 75.9C296.3 74.9 296.9 74.2 297.7 73.7C298.6 73.2 299.6 73 300.7 73.3L349.6 88C351.6 88.6 352.7 90.7 352.1 92.7Z",
    fill: "#7A4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.8 79.8L289.2 121.7L281.1 127.2C280.9 126.6 280.4 124.7 280.6 124.2L295.2 76.7C295.5 75.7 296.8 73 298 73.4L301.8 79.8Z",
    fill: "#5A2C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.5 144.5C334.6 145 333.6 145.2 332.6 144.9L283.7 130.2C282.4 129.8 281.4 128.6 281.2 127.3L289.3 121.8L330.5 134.2L335.5 144.5Z",
    fill: "#441C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.4 85.2L345.6 92.4L339.4 113C339.4 113 342.6 96.2 341.3 94.7C340 93.2 321.4 85.2 321.4 85.2Z",
    fill: "#AF7D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6 267.4C73.1 302 144.6 308.2 171.2 310.4C238.7 314.8 307 310 373.9 301.2C382.1 300.1 389.6 305.8 390.8 314C391.9 322.2 386.2 329.7 378 330.9C349.9 333 321.9 333.8 293.9 333.8C237.4 333.4 124 331.2 79.5 297.1C70.4 290.1 63.4 279.3 64 267.4C64.4 262.4 71.4 262.5 71.6 267.4Z",
    fill: "#FFE600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20280_301274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChocolate);
export default __webpack_public_path__ + "static/media/Chocolate.e43cb9e3.svg";
export { ForwardRef as ReactComponent };